import { guest } from '../../plugin/axios'

export default{
  namespaced:true,
 state:{
    crms: [],
    crm: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null,

    offers: [],
    offer: null,
    offerIsLoading: false,
    offerIsCreating: false,
    offerCreatedData: null,
    offerIsUpdating: false,
    offerUpdatedData: null,
    offerIsDeleting: false,
    offerdeletedData: null,

    
},
mutations:{
    setCrms: (state, crms) => {
        state.crms = crms
    },
    setOffers: (state, offers) => {
        state.offers = offers
    },
    setCrmDetail: (state, crm) => {
        state.crm = crm
    },
    setOfferDetail: (state, offer) => {
        state.offer = offer
    },
    saveNewCrms: (state, crm) => {
        state.crms.unshift(crm)
        state.createdData = crm
    },

    saveNewOffers: (state, offer) => {
        state.offers.unshift(offer)
        state.offerCreatedData = offer
    },
    saveUpdatedCrm: (state, crm) => {
        // Find index
        // state.crms.unshift(crm)
        state.updatedData = crm
        const index = state.crms.findIndex(
            (crm) => crm.id === state.updatedData.id
        )
        if (index !== -1) {
            state.crms.splice(index, 1, state.updatedData)
        }
    },
    setDeleteCrm: (state, id) => {
        const index = state.crms
            .map((x) => {
                return x.id
            })
            .indexOf(id)
        state.crms.splice(index, 1)
    },

    setDeleteOffer: (state, id) => {
        const index = state.offers
            .map((x) => {
                return x.id
            })
            .indexOf(id)
        state.offers.splice(index, 1)
    },
    setCrmIsLoading(state, isLoading) {
        state.isLoading = isLoading
    },
    setCrmIsCreating(state, isCreating) {
        state.isCreating = isCreating
    },

    setOfferIsCreating(state, isCreating) {
        state.offerIsCreating = isCreating
    },

    setCrmIsUpdating(state, isUpdating) {
        state.isUpdating = isUpdating
    },
    setCrmIsDeleting(state, isDeleting) {
        state.isDeleting = isDeleting
    },
    setOfferIsDeleting(state, isDeleting) {
        state.offerIsDeleting = isDeleting
    },
},
actions:{
    async fetchAllCrms({ commit }) {
        commit('setCrmIsLoading', true)
        await guest
            .get('/crms')
            .then((res) => {
                const crms = res.data.crm
                commit('setCrms', crms)

                commit('setCrmIsLoading', false)
            })
            .catch((err) => {
                this.$toast.error(err)
                commit('setCrmIsLoading', false)
            })
    },

    async fetchAllOffers({ commit }) {
        commit('setOfferIsLoading', true)
        await guest
            .get('/offers')
            .then((res) => {
                const crms = res.data.crm
                commit('setOffers', crms)

                commit('setOfferIsLoading', false)
            })
            .catch((err) => {
                this.$toast.error(err)
                commit('setOfferIsLoading', false)
            })
    },
    async fetchAllCrmsLatest({ commit }) {
        commit('setCrmIsLoading', true)
        await guest
            .get('/latest-crms')
            .then((res) => {
                const crms = res.data.crm
                commit('setCrms', crms)

                commit('setCrmIsLoading', false)
            })
            .catch((err) => {
                this.$toast.error(err)
                commit('setCrmIsLoading', false)
            })
    },
    async storeCrm({ commit }, crm) {
        commit('setCrmIsCreating', true)
        await guest
            .post('/booking-inspection-sell-store', crm)
            .then((res) => {
                if (res.data.email) {
                    this.$toast.error(res.data.email[0])
                    commit('setCrmIsCreating', false)
                } else {
                    commit('saveNewCrms', res.data.crm)
                    commit('setCrmIsCreating', false)
                }
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    commit('setCrmIsCreating', false)
                    this.$toast.error('Field Not Properly Filled')
                }
            })
    },
    async storeOffer({ commit }, offer) {
        commit('setOfferIsCreating', true)
        await guest
            .post('/offers-store', offer)
            .then((res) => {
                if (res.data.email) {
                    this.$toast.error(res.data.email[0])
                    commit('setCrmIsCreating', false)
                } else {
                    commit('saveNewOffers', res.data.offer)
                    commit('setOfferIsCreating', false)
                }
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    commit('setOfferIsCreating', false)
                    this.$toast.error('Field Not Properly Filled')
                }
            })
    },
    async storeSalesCrm({ commit }, crm) {
        commit('setCrmIsCreating', true)
        await guest
            .post('/booking-sell-car-inspection-store', crm)
            .then((res) => {
                if (res.data.email) {
                    this.$toast.error(res.data.email[0])
                    commit('setCrmIsCreating', false)
                } else {
                    commit('saveNewCrms', res.data.crm)
                    commit('setCrmIsCreating', false)
                }
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    commit('setCrmIsCreating', false)
                    this.$toast.error('Field Not Properly Filled')
                }
            })
    },
    async fetchDetailCrm({ commit }, id) {
        commit('setCrmIsLoading', true)
        await guest
            .get(`crms-show/${id}`)
            .then((res) => {
                commit('setCrmDetail', res.data.crm)
                commit('setCrmIsLoading', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Field Not Properly Field')
                    commit('setCrmIsLoading', false)
                }
            })
    },
    async updateCrm({ commit }, crm) {
        commit('setCrmIsUpdating', true)
        await guest
            .post(`crms-update/${crm.id}`, crm)
            .then((res) => {
                commit('saveUpdatedCrm', res.data.crm)
                commit('setCrmIsUpdating', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Fields not properly filled')
                    commit('setCrmIsUpdating', false)
                }
            })
    },
    async deleteCrm({ commit }, id) {
        commit('setCrmIsDeleting', true)
        await guest
            .delete(`crms-delete/${id}`)
            .then((res) => {
                commit('setDeleteCrm', res.data.crm.id)
                commit('setCrmIsDeleting', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Field Not Properly Filled')
                    commit('setCrmIsDeleting', false)
                }
            })
    },

    async deleteOffer({ commit }, id) {
        commit('setOfferIsDeleting', true)
        await guest
            .delete(`offers-delete/${id}`)
            .then((res) => {
                commit('setDeleteOffer', res.data.crm.id)
                commit('setOfferIsDeleting', false)
            })
            .catch((err) => {
                if (err.response.status === 422) {
                    this.$toast.error('Field Not Properly Filled')
                    commit('setOfferIsDeleting', false)
                }
            })
    },
},
getters:{
    crmList: (state) => state.crms,
    offerList: (state) => state.offers,
    crm: (state) => state.crm,
    offer: (state) => state.offer,
    isLoading: (state) => state.isLoading,
    offerIsLoading: (state) => state.offerIsLoading,
    isCreating: (state) => state.isCreating,
    offerIsCreating: (state) => state.offerIsCreating,
    isUpdating: (state) => state.isUpdating,
    createdData: (state) => state.createdData,
    offerCreatedData: (state) => state.offerCreatedData,
    updatedData: (state) => state.updatedData,
    isDeleting: (state) => state.isDeleting,
    offerIsDeleting: (state) => state.offerIsDeleting,
    deletedData: (state) => state.deletedData,
    offerDeletedData: (state) => state.offerDeletedData,
},

}